import { useCallback } from 'react';
import { UserInterfaceSettings } from '../../state';
import { ExpiryType, ListedInstrument, NbSelectItemOption, OrderType } from '../../types';
import { useNonTradingDaysCommon } from './useNonTradingDays';

type UseOrderExpiryTypeCommonParams = {
  getExpiryTypeOptions: (
    instrument: ListedInstrument | null | undefined,
    orderType: OrderType,
  ) => NbSelectItemOption<ExpiryType>[];
  userInterfaceSettings: UserInterfaceSettings;
};

type UseOrderExpiryTypeCommonOutput = {
  getDefaultExpiryType: (instrument: ListedInstrument | null | undefined, orderType: OrderType) => ExpiryType;
  getDefaultExpiryDate: (instrument: ListedInstrument | null | undefined, expiryType: ExpiryType) => Date | undefined;
};

export const useOrderExpiryTypeCommon = ({
  getExpiryTypeOptions,
  userInterfaceSettings,
}: UseOrderExpiryTypeCommonParams): UseOrderExpiryTypeCommonOutput => {
  const { getNextTradingDay } = useNonTradingDaysCommon();
  const getDefaultExpiryType = useCallback(
    (instrument: ListedInstrument | null | undefined, orderType: OrderType): ExpiryType => {
      const expiryTypeOptions = getExpiryTypeOptions(instrument, orderType);
      const expiryType = !expiryTypeOptions.some(e => e.id === userInterfaceSettings.orderDefaults.expiryType)
        ? (expiryTypeOptions[0]?.id as ExpiryType) ?? undefined
        : userInterfaceSettings.orderDefaults.expiryType;

      return expiryType;
    },
    [getExpiryTypeOptions, userInterfaceSettings.orderDefaults.expiryType],
  );

  const getDefaultExpiryDate = useCallback(
    (instrument: ListedInstrument | null | undefined, expiryType: ExpiryType): Date | undefined => {
      return expiryType === ExpiryType.Gtd && instrument?.mic ? getNextTradingDay(instrument?.mic) : undefined;
    },
    [getNextTradingDay],
  );

  return {
    getDefaultExpiryType,
    getDefaultExpiryDate,
  };
};
